module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-6.ad8522f2.svg";